import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useQltAuthStore } from '../stores/qlt';
import { Spinner } from '../components';
import { useSignOut } from './useSignOut';

export function AuthGate({ children }: { children: ReactNode }) {
  const jwt = useQltAuthStore((state) => state.jwt);
  const isTeacher = useQltAuthStore((state) => state.isTeacher);
  const hydrating = useQltAuthStore((state) => state.hydrating);
  const signOut = useSignOut();
  const location = useLocation();
  if (hydrating) return <div className="auth-gate-state"><Spinner label="Đang xác minh phiên đăng nhập" size="large" /></div>;
  if (!jwt) {
    return <Navigate to="/login" replace={true} state={{ from: location.pathname + location.search }} />;
  }
  if (!isTeacher) return <main className="auth-gate-state"><div><h1>Bảng dành cho giáo viên</h1><p>Tài khoản hiện tại không có vai trò giáo viên.</p><button type="button" className="primary-button" onClick={signOut}>Đăng nhập tài khoản khác</button></div></main>;
  return <>{children}</>;
}

export default AuthGate;
